import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import ContentPreview from '../ContentPreview';

export default ({ isOpen, onClose, title, contents }) => {
  const { t } = useTranslation(['button']);

  return (
    <Dialog open={isOpen} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent dividers>
        {isOpen && <ContentPreview contents={contents} />}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          {t('button:commons.btn_close')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
